import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { AuthCallbackComponent } from './features/auth-callback/auth-callback.component';
import { customAuthGuard } from './core/guards/customAuthGuard';
import { NgModule } from '@angular/core';
import { Role } from './core/enums/role.enum';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        canActivate: [() => customAuthGuard()],
        loadChildren: () =>
          import('./features/dashboard/dashboard.routes').then(
            (m) => m.DASHBOARD_ROUTES
          ),
        data: { animation: 'dashboard' },
      },
      {
        path: 'profile',
        canActivate: [() => customAuthGuard()],
        loadChildren: () =>
          import('./features/profile/profile.routes').then(
            (m) => m.PROFILE_ROUTES
          ),
        data: { animation: 'profile' },
      },
      {
        path: 'help',
        canActivate: [() => customAuthGuard()],
        loadChildren: () =>
          import('./features/help/help/help-home.routes').then(
            (m) => m.HELP_ROUTES
          ),
        data: { animation: 'help' },
      },
      {
        path: 'environment',
        canActivate: [() => customAuthGuard()],
        loadChildren: () =>
          import('./features/environment/environment.routes').then(
            (m) => m.ENVIRONMENT_ROUTES
          ),
        data: { animation: 'environment' },
      },
      {
        path: 'tasks',
        canActivate: [() => customAuthGuard()],
        loadChildren: () =>
          import('./features/task/task.routes').then(
            (m) => m.TASK_ROUTES
          ),
        data: { animation: 'tasks' },
      },
      {
        path: 'audit-logs',
        canActivate: [() => customAuthGuard([Role.Administrator])],
        loadChildren: () =>
          import('./features/audit-log/audit-logs.routes').then(
            (m) => m.AUDIT_LOGS_ROUTES
          ),
        data: { animation: 'audit-logs' },
      },
      {
        path: 'inspection-bucket',
        canActivate: [() => customAuthGuard()],
        loadChildren: () =>
          import(
            './features/inspection-buckets/inspection-bucket.routes'
          ).then((m) => m.INSPECTION_DATA),
        data: { animation: 'inspection-bucket' },
      },
      {
        path: 'inspection',
        canActivate: [() => customAuthGuard()],
        loadChildren: () =>
          import(
            './features/inspection-buckets/inspection-bucket.routes'
          ).then((m) => m.INSPECTION_DETAIL),
        data: { animation: 'inspection-bucket' },
      },
      {
        path: 'create-inspection',
        canActivate: [() => customAuthGuard()],
        loadChildren: () =>
          import(
            './features/inspection-buckets/inspection-bucket.routes'
          ).then((m) => m.CREATE_INSPECTION),
        data: { animation: 'create-inspection' },
      },
      {
        path: 'scanners',
        canActivate: [() => customAuthGuard()],
        loadChildren: () =>
          import('./features/scanners/scanners.routes').then(
            (m) => m.SYSTEM_TYPES_ROUTES
          ),
        data: { animation: 'scanners' },
      },
      {
        path: 'file-manager',
        canActivate: [() => customAuthGuard()],
        loadChildren: () =>
          import('./features/file-manager/file-manager.routes').then(
            (m) => m.FILEMANAGER_ROUTES
          ),
        data: { animation: 'file-manager' },
      },
    ],
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: 'auth-callback',
    component: AuthCallbackComponent,
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./features/error/error.routes').then((m) => m.ERROR_ROUTES),
  },
];


@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}